import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { BulkEditEvent } from './bulk-edit-event.interface';

@Injectable({
    providedIn: 'root',
})
export class BulkEditStateService {
    private bus = new BehaviorSubject<BulkEditEvent>(null);

    public get state$() {
        return this.bus.asObservable();
    }

    public get state() {
        return this.bus.value;
    }

    public emit(event: BulkEditEvent) {
        this.bus.next(event);
    }
}
